export const servicesData = [
  {
    title: "UI/UX",
    items: [
      "Design and implementation of modern, responsive, mobile-first user interfaces.",
      "Component-based UI systems using React, TypeScript, and Atomic Design principles.",
      "Translation of Figma designs into clean, scalable, and accessible front-end code.",
      "Performance optimization and UX improvements for faster load times and smoother interactions.",
    ],
  },
  {
    title: "Web Development",
    items: [
      "Development of scalable web applications using React, Next.js, and TypeScript.",
      "Dashboards, admin panels, and role-based interfaces for real-world business workflows.",
      "PWA development with offline-first capabilities and real-time updates.",
      "API integration, authentication (JWT, OAuth), and secure data handling.",
      "Firebase-based backends (Auth, Firestore, Cloud Functions, Hosting).",
      "CI/CD setup, testing, and performance monitoring for production-ready apps.",
    ],
  },
  {
    title: "Mobile App Development",
    items: [
      "Cross-platform mobile apps using React Native and Expo.",
      "Offline-first mobile experiences with reliable data synchronization.",
      "App Store and Google Play deployment, updates, and maintenance.",
      "OTA updates, performance tuning, and mobile debugging.",
      "End-to-end feature delivery from concept to production.",
    ],
  },
];
